const cognito_prd_client_id = '7drdcmut4up68pogttda1jrtq7';
const cognito_prd_pool_id = 'eu-west-1_fH5LcXrK5';
const cognito_tst_client_id = '5olsjk6guei8kt1pvp0i77v5tq'; // 60 min token expiration
// const cognito_tst_client_id = 's62qp9c85frpga678r8us34m9';  // 5 min token expiration
const cognito_tst_pool_id = 'eu-west-1_d24gjBHw2';

const cognitoClientId = process.env?.REACT_APP_HOST_TYPE === 'local-cognito-test' ?
  cognito_tst_client_id : cognito_prd_client_id;
const cognitoUserPoolId = process.env?.REACT_APP_HOST_TYPE === 'local-cognito-test' ?
  cognito_tst_pool_id : cognito_prd_pool_id;

export const APP_CONFIG = {
  name: 'SciScore',
  logo: '/img/SciScore_Logo.svg',
  system: 'sciscore',
  restrictedDomain: '', // add any restricted domains here ';' separated. asedasciences.com is always allowed
  cognitoClientId: cognitoClientId,
  cognitoUserPoolId: cognitoUserPoolId,
  loginInfo: [
    'An account is required to access SciScore. ',
    'This same account allows access to other AsedaSciences applications and services such as 3RnD. ',
    'Creating an account is a three step process: (1) Enter email/password (2) Verify email, and (3) Registering.'
  ],
  createAccountInfo: [
    'Creating an account is a three step process: (1) Enter email/password (2) Verify email, and (3) Registering.',
    'This is step (1) Enter your email and set a password.'
  ],
  verifyEmailInfo: [
    'Creating an account is a three step process: (1) Enter email/password (2) Verify email, and (3) Registering.',
    'This is step (2) to verify your email.',
    'Code was sent to your email upon step (1) from support@asedasciences.com. ' +
    'Check trash and spam folders, if necessary.'
  ],
  userRegisterInfo: [
    'Creating an account is a three step process: (1) Enter email/password (2) Verify email, and (3) Registering.',
    'This is step (3) to provide basic user account information.',
    'This is a one-time process for all AsedaSciences applications and this information can be updated later if needed.'
  ]
};
